import { FileCheck } from 'lucide-react';
import * as React from 'react';

import type { DiscriminatedMatterRetainerSignedByClientEvent } from '@/services/api/generated/taskActivityService';

import { EventBody, EventContainer, EventHeader } from './EventPrimitives';

interface MatterRetainerSignedByClientEventProps {
  event: DiscriminatedMatterRetainerSignedByClientEvent;
  matterId: string;
}

export const MatterRetainerSignedByClientEvent: React.FC<
  MatterRetainerSignedByClientEventProps
> = ({ event, matterId }) => {
  const { payload, occurred_at, user, agent } = event;
  const { matter } = payload;

  // Get client names
  const clientNames = matter.clients
    ?.map((client) => client.name)
    .filter(Boolean)
    .join(', ');

  return (
    <EventContainer>
      <EventHeader
        icon={<FileCheck size={20} />}
        title="Retainer Signed by Client"
        timestamp={occurred_at}
        actor={user}
        agent={agent}
      />

      <EventBody>
        <div className="text-xs text-slate-700">
          {clientNames ? (
            <>
              <span className="font-medium">{clientNames}</span> signed the
              retainer agreement.
            </>
          ) : (
            <>The client signed the retainer agreement.</>
          )}
        </div>
      </EventBody>
    </EventContainer>
  );
};
